/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3MetricsLatestRewardEventTotalAvailableFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsLatestRewardEventTotalAvailableFormat = ClosedEnum<
  typeof GetApiV3MetricsLatestRewardEventTotalAvailableFormat
>;

export type GetApiV3MetricsLatestRewardEventTotalAvailableRequest = {
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3MetricsLatestRewardEventTotalAvailableFormat | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Float Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsLatestRewardEventTotalAvailableFormat$inboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsLatestRewardEventTotalAvailableFormat> =
    z.nativeEnum(GetApiV3MetricsLatestRewardEventTotalAvailableFormat);

/** @internal */
export const GetApiV3MetricsLatestRewardEventTotalAvailableFormat$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsLatestRewardEventTotalAvailableFormat> =
    GetApiV3MetricsLatestRewardEventTotalAvailableFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsLatestRewardEventTotalAvailableFormat$ {
  /** @deprecated use `GetApiV3MetricsLatestRewardEventTotalAvailableFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsLatestRewardEventTotalAvailableFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsLatestRewardEventTotalAvailableFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsLatestRewardEventTotalAvailableFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsLatestRewardEventTotalAvailableRequest$inboundSchema:
  z.ZodType<
    GetApiV3MetricsLatestRewardEventTotalAvailableRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    end: z.nullable(z.number()).default(null),
    format: GetApiV3MetricsLatestRewardEventTotalAvailableFormat$inboundSchema
      .default("json"),
    start: z.nullable(z.number()).default(null),
    step: z.number().default(7200),
  });

/** @internal */
export type GetApiV3MetricsLatestRewardEventTotalAvailableRequest$Outbound = {
  end: number | null;
  format: string;
  start: number | null;
  step: number;
};

/** @internal */
export const GetApiV3MetricsLatestRewardEventTotalAvailableRequest$outboundSchema:
  z.ZodType<
    GetApiV3MetricsLatestRewardEventTotalAvailableRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3MetricsLatestRewardEventTotalAvailableRequest
  > = z.object({
    end: z.nullable(z.number()).default(null),
    format: GetApiV3MetricsLatestRewardEventTotalAvailableFormat$outboundSchema
      .default("json"),
    start: z.nullable(z.number()).default(null),
    step: z.number().default(7200),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsLatestRewardEventTotalAvailableRequest$ {
  /** @deprecated use `GetApiV3MetricsLatestRewardEventTotalAvailableRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsLatestRewardEventTotalAvailableRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsLatestRewardEventTotalAvailableRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsLatestRewardEventTotalAvailableRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsLatestRewardEventTotalAvailableRequest$Outbound` instead. */
  export type Outbound =
    GetApiV3MetricsLatestRewardEventTotalAvailableRequest$Outbound;
}

export function getApiV3MetricsLatestRewardEventTotalAvailableRequestToJSON(
  getApiV3MetricsLatestRewardEventTotalAvailableRequest:
    GetApiV3MetricsLatestRewardEventTotalAvailableRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsLatestRewardEventTotalAvailableRequest$outboundSchema.parse(
      getApiV3MetricsLatestRewardEventTotalAvailableRequest,
    ),
  );
}

export function getApiV3MetricsLatestRewardEventTotalAvailableRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3MetricsLatestRewardEventTotalAvailableRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsLatestRewardEventTotalAvailableRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3MetricsLatestRewardEventTotalAvailableRequest' from JSON`,
  );
}
